"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _scrollBox = _interopRequireDefault(require("../../scroll-box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var FilterMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterMenu, _React$Component);

  function FilterMenu(props) {
    var _this;

    _classCallCheck(this, FilterMenu);

    _this = _possibleConstructorReturn(this, (FilterMenu.__proto__ || Object.getPrototypeOf(FilterMenu)).call(this, props));
    _this.getFilterCount = _this.getFilterCount.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      if (!this.props.visible) return null;
      var resetReady = false;
      this.props.filter.map(function (filter) {
        if (_this2.props.filters[filter.key].length > 0) {
          resetReady = true;
        }
      });
      var showResultNumber = false;

      if (parseInt(this.props.numbersOfResults)) {
        showResultNumber = true;
      }

      var plusIcon = /*#__PURE__*/_react.default.createElement("div", {
        className: 'plus-icon-button'
      }, /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 15.2 15.2"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: 'M8.234 8.272h5.94c.354.07.707-.283.707-.566s-.212-.777-.495-.777H8.305l-.07-6.01c.07-' + '.354-.283-.566-.637-.637-.354.07-.636.353-.636.636v5.94l-6.01.07c-.425 0-.708.283-.637.637s.283.' + '707.636.636h5.94v5.94c0 .424.353.637.636.637.354-.071.637-.354.637-.637l.07-5.869z'
      })));

      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'filter-menu'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'filter-menu-header clearfix'
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: 'close-filter-detail-selection',
        onClick: this.props.closeModal
      }), /*#__PURE__*/_react.default.createElement("a", {
        href: '#',
        className: "filter-menu-link-reset ".concat(resetReady ? 'ready' : ''),
        onClick: this.props.onResetAll
      }, t('Zurücksetzen'))), /*#__PURE__*/_react.default.createElement(_scrollBox.default, null, /*#__PURE__*/_react.default.createElement("ul", {
        className: 'filter-menu-list'
      }, this.props.filter.map(function (filter, key) {
        if (filter.key === 'product' || filter.key === 'products') {
          if (document.body.classList.item(0) === 'schub') {
            return null;
          }
        }

        if (filter.key === 'soldout') {
          return null;
        }

        if (filter.key === 'product') {
          return null;
        }

        var filterCount = _this2.getFilterCount(_this2.props.filters, filter);

        return /*#__PURE__*/_react.default.createElement("li", {
          key: key,
          className: 'filter-menu-list-item',
          onClick: function onClick() {
            return _this2.props.onMenuClick(filter.key);
          }
        }, t(filter.label), " ", filterCount, plusIcon);
      }))), /*#__PURE__*/_react.default.createElement("button", {
        className: "summary-button ".concat(this.props.isReadyToSearch() ? 'ready' : ''),
        onClick: this.props.onShowResultsClick
      }, !showResultNumber && t('Übernehmen'), showResultNumber && t('search-result', {
        count: parseInt(this.props.numbersOfResults)
      })));
    }
  }, {
    key: "getFilterCount",
    value: function getFilterCount(activeFilter, filter) {
      var key = filter.key;

      if (!activeFilter[key].length > 0) {
        return '';
      } else {
        return '(' + activeFilter[key].length + ')';
      }
    }
  }]);

  return FilterMenu;
}(_react.default.Component);

FilterMenu.propTypes = {
  t: _propTypes.default.func.isRequired,
  isReadyToSearch: _propTypes.default.func.isRequired,
  filter: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    key: _propTypes.default.string
  })),
  closeModal: _propTypes.default.func.isRequired,
  onResetAll: _propTypes.default.func.isRequired,
  onShowResultsClick: _propTypes.default.func.isRequired,
  visible: _propTypes.default.bool,
  onMenuClick: _propTypes.default.func,
  filters: _propTypes.default.object,
  numbersOfResults: _propTypes.default.number
};
var _default = FilterMenu;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-filter/lib/filter-menu.js
// module id = 878
// module chunks = 0